import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { observer } from "mobx-react";
import { StatsMainBarChart, StatsCustomBypassPieChart, StatsButtonClickedPieChart } from ".";
import { useStores } from "../../../../store";
import { __ } from "../../../../utils";
import { DateRangePicker } from "../../..";
import { Row, Col, Divider, Empty, Select } from "antd";
import { useAvailableDateRangesForFilter } from "../../../../hooks";
import { UpsellModal } from "@devowl-wp/react-cookie-banner-admin";
const StatsGrid = observer(()=>{
    const { optionStore: { others: { isPro, assetsUrl }, contexts }, statsStore } = useStores();
    const { filters: { dates, context } } = statsStore;
    const contextKeys = Object.keys(contexts);
    const [statsLiteInContainerRef, setStatsLiteInContainerRef] = useState();
    // Provide predefined ranges to the user
    const availableRanges = useAvailableDateRangesForFilter();
    return isPro ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    textAlign: "right"
                },
                children: [
                    contextKeys.length > 1 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: /*#__PURE__*/ _jsx(Select, {
                                    style: {
                                        width: 200,
                                        textAlign: "left"
                                    },
                                    value: context,
                                    onSelect: (e)=>statsStore.applyContext(e),
                                    children: contextKeys.map((context)=>/*#__PURE__*/ _jsx(Select.Option, {
                                            value: context,
                                            children: contexts[context]
                                        }, context))
                                })
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                type: "vertical"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("label", {
                        children: [
                            __("Period"),
                            ":",
                            " ",
                            /*#__PURE__*/ _jsx(DateRangePicker, {
                                value: /* Ant design relies on moment 2.27 and typings are currently incompatible with other moment typings */ dates,
                                ranges: availableRanges,
                                onChange: (dates)=>statsStore.applyDates(dates)
                            })
                        ]
                    })
                ]
            }),
            (dates == null ? void 0 : dates.length) === 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsxs(Col, {
                                md: 12,
                                sm: 24,
                                children: [
                                    /*#__PURE__*/ _jsx(Divider, {
                                        children: __("Consents by clicked button")
                                    }),
                                    /*#__PURE__*/ _jsx(StatsButtonClickedPieChart, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Col, {
                                md: 12,
                                sm: 24,
                                children: [
                                    /*#__PURE__*/ _jsx(Divider, {
                                        children: __("Cookie banner bypass")
                                    }),
                                    /*#__PURE__*/ _jsx(StatsCustomBypassPieChart, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Row, {
                        children: /*#__PURE__*/ _jsxs(Col, {
                            md: 20,
                            sm: 24,
                            style: {
                                margin: "auto",
                                paddingTop: 20,
                                marginTop: 30
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Divider, {
                                    children: __("Consents by group")
                                }),
                                /*#__PURE__*/ _jsx(StatsMainBarChart, {})
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Empty, {
                description: __("Please provide a date range!")
            })
        ]
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(UpsellModal, {
                title: __("Want to see detailed statistics about the consents of your visitors?"),
                inContainer: true,
                inContainerElement: statsLiteInContainerRef,
                testDrive: true,
                feature: "stats",
                description: __("You can get several statistics about how your users use the cookie banner. This helps you to calculate the total number of users who do not want to be tracked, for example, by extrapolating data from Google Analytics.")
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: setStatsLiteInContainerRef,
                className: "rcb-antd-modal-mount",
                style: {
                    height: 800,
                    backgroundImage: `url('${assetsUrl}statistics-blured.png')`
                }
            })
        ]
    });
});
export { StatsGrid };
